<script>
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('btn')],
        props: {
            tag: {
                type: String,
                default() {
                    return 'button';
                },
            },
            size: {
                type: String,
                default() {
                    return 'medium';
                },
            },
        },
        render(createElement) {
            const { tag, size, bemFacets, bemRoot } = this;
            const children = this.$slots.default;

            // button children components
            // they will wrapped in a div with the class 'text' or 'icon'
            // <div class='btn--text'>{child}</div>
            const buttonChildren = children.map(child => (
                createElement('div', {
                    class: `btn--${ child.text ? 'text' : 'icon' }`,
                }, [child.text || child])
            ));

            // button children wrapper component: icons, text...
            const buttonWrap = createElement('div', {
                class: 'btn--wrap',
            }, buttonChildren);

            // the final button markup
            return createElement(tag, {
                class: [
                    bemRoot,
                    ...bemFacets,
                    this.bemAdd(size),
                ],
                attrs: {
                    ...this.$attrs,
                },
            }, [buttonWrap]);
        },
    };
</script>
